import { render, staticRenderFns } from "./TabInformation.vue?vue&type=template&id=17082c6b"
import script from "./TabInformation.vue?vue&type=script&lang=js"
export * from "./TabInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports